/**
 * TLD default selection helper.
 * Prefers .com when available instead of "Auto (N domains available)".
 * For Media Devoted | Created By Ciro Autiero
 */

/** Prefer .com as default TLD when available; otherwise the first real TLD.
 *  Auto is always offered (first in the list) but stays an explicit pick. */
export function getDefaultTldValue(
  tlds: { value: string; displayName?: string }[],
): string {
  const com = tlds.find(
    (t) => t.value === 'com' || t.value === '.com',
  );
  const firstReal = tlds.find((t) => t.value.toLowerCase() !== 'auto');
  return com?.value ?? firstReal?.value ?? tlds[0]?.value ?? '';
}
